<template>
  <component :is="$route.meta.Layout" />
</template>

<script>
export default {
}
</script>